import React from 'react';

export default function ContactDifference() {
  return (
    <div>
      <div className="team_area pt-45 pb-40">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section_title text_left mb-60 mt-3">
                <div className="section_main_title text-left">
                  <h2>Details That Make The Difference</h2>
                 
                </div>
                <div className="em_bar">
                  <div className="em_bar_bg"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div className="team_style_three mb-30">
                <div className="team_style_three_inner">
                  <div className="team_style_three-thumb">
                    <div className="team_style_three_thumb_inner">
                      <img src="assets/images/1.png" alt="Human verified contact data" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div className="team_style_three mb-30">
                <div className="team_style_three_inner">
                  <div className="team_style_three-thumb">
                    <div className="team_style_three_thumb_inner">
                      <img src="assets/images/2.png" alt="verified mobile DID" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div className="team_style_three mb-30">
                <div className="team_style_three_inner">
                  <div className="team_style_three-thumb">
                    <div className="team_style_three_thumb_inner">
                      <img src="assets/images/3.png" alt="job titles" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div className="team_style_three mb-30">
                <div className="team_style_three_inner">
                  <div className="team_style_three-thumb">
                    <div className="team_style_three_thumb_inner">
                      <img src="assets/images/4.png" alt="profiles" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
}
